export const initialHTML = `
  Bandicoot is a refreshingly simple tool that provides you:
  <ul>
    <li>an approachable and understandable api surface area</li>
    <li>an incredibly small package size(14kb not gzipped)</li>
    <li>extensibility without sacrificing usability</li>
  </ul>
  <div>Rich text is inherently complicated, but the library you use for it shouldn't make it more complicated</div>
  Check out the docs <a href='https://bandicoot.js.org/'>here</a>.

`;
